import {createContext, useEffect, useState} from "react";
import {useTranslation} from "react-i18next";

const ConfigContext = createContext();

export default ConfigContext;

export const ConfigProvider = ({ children }) => {
    const language = localStorage.getItem('lang') || navigator.language
    console.log(navigator.language)
    const [appLanguage, setAppLanguage] = useState(language)
    const {i18n} = useTranslation()

    useEffect(() => {
        i18n.changeLanguage(appLanguage)
        localStorage.setItem('lang', appLanguage)
    }, [appLanguage])

    const contextData = {
        baseUrl: 'https://admin.tourguidesystem.hu/',
        /* baseUrl: 'https://tourguideback.trilogic.hu/', */
        language: appLanguage,
        setAppLanguage: setAppLanguage
    }

    return <ConfigContext.Provider value={contextData}>{children}</ConfigContext.Provider>
}